import { render } from "./DisciplinaryHrActions.vue?vue&type=template&id=58cd3f92&scoped=true"
import script from "./DisciplinaryHrActions.vue?vue&type=script&lang=js"
export * from "./DisciplinaryHrActions.vue?vue&type=script&lang=js"

import "./DisciplinaryHrActions.vue?vue&type=style&index=0&id=58cd3f92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cd3f92"]])

export default __exports__